var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0837 2.75H0.916992V5.34417L11.0003 10.4317L21.0837 5.34325V2.75Z",
    fill: "#3A6AB6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0837 7.39658L11.0003 12.485L0.916992 7.39749V19.25H21.0837V7.39658Z",
    fill: "#3A6AB6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.5ad0bc47df35b2be6131c075114468c7.svg";
export { ForwardRef as ReactComponent };